import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MoveObjectEventService {

  public pos: string; // should be the current position of asset
  public eventIndex;
  public settingMoveObjectEvent = false;
  public movingAsset;
  public triggeringAsset;
  
  constructor() { }
}
